import { Modal, Tabs } from "antd";
import { ContentHistoryVersion } from "../components/editor/content-history-version/content-history-version-v2";
import { useState } from "react";
import { HistoryVersionDiffView } from "../components/editor/content-history-version/history-version-diff-view";
import { useSearchParams } from "../../../hook/use-search-params";

type HistoryVersionContentModalType = {
  isOpenModal: boolean;
  onClose: () => void;
};

const items = [
  {
    label: "Các phiên bản soạn thảo",
    key: "1",
  },
  {
    label: "Tóm tắt nội dung thay đổi",
    key: "2",
  },
];

export const ContentHistoryVersionModal = ({ isOpenModal, onClose }: HistoryVersionContentModalType) => {
  const [activeTab, setActiveTab] = useState("1");
  const { searchParams, replaceSearchParams } = useSearchParams();

  const handleTabChange = (key: string) => {
    setActiveTab(key);
    resetParams();
  };

  const resetParams = () => {
    searchParams.delete("currentVersion");
    searchParams.delete("previousVersion");
    replaceSearchParams(searchParams);
  };

  const ModalTitle = <Tabs activeKey={activeTab} onChange={handleTabChange} defaultActiveKey="1" items={items}></Tabs>;
  return (
    <Modal
      title={ModalTitle}
      centered
      open={isOpenModal}
      onCancel={onClose}
      width={"100%"}
      okButtonProps={{ hidden: true }}
      cancelText="Đóng"
      className="py-4 overflow-hidden"
      destroyOnClose
      footer={() => null}
      afterClose={() => resetParams()}
    >
      {activeTab === "1" && <ContentHistoryVersion />}
      {activeTab === "2" && <HistoryVersionDiffView />}
    </Modal>
  );
};
